// @flow
import { authenticatedFetch } from '../../../api/request';

export default async function setNotificationsAsViewed(ids: Array<number>) {
    const url = '/v5/notifications/viewed';
    const payload = {
        notificationIds: ids.join()
    };
    return await authenticatedFetch(url, {
        method: 'PUT',
        body: JSON.stringify(payload)
    });
}
